import React from 'react';
import { List, Typography } from 'antd';
import {PropertyFull} from "../../types";
import { renderDetail, hasCustomRenderer } from '../../utils/detailRendererRegistry';

const { Text } = Typography;

export interface PropertyItemProps {
    property: PropertyFull;
    /**
     * Массив действий, которые будут отображаться справа от содержимого элемента.
     * Каждый элемент – отдельный компонент (например, для сравнения, редактирования, удаления).
     */
    actions: React.ReactNode[];
    /**
     * Функция для рендера содержимого. Если не передана – по умолчанию выводится property.text.
     */
    renderContent?: (property: PropertyFull) => React.ReactNode;
}

const PropertyItem: React.FC<PropertyItemProps> = ({ property, actions, renderContent }) => {
    const defaultRenderContent = (prop: PropertyFull): React.ReactNode => {
        const structuredDetails = (prop.details ?? []).filter(d => hasCustomRenderer(d.code));
        return (
            <div>
                <span>{prop.text}</span>
                {structuredDetails.map(d => (
                    <div key={d.code} style={{ marginTop: 8 }}>
                        <Text type="secondary" style={{ fontSize: 12 }}>{d.name}</Text>
                        {renderDetail(d)}
                    </div>
                ))}
            </div>
        );
    };

    const content = renderContent ? renderContent(property) : defaultRenderContent(property);

    return (
        <List.Item actions={actions}>
            {content}
        </List.Item>
    );
};

export default React.memo(PropertyItem);
